import React, {useEffect, useState} from 'react';
import {Button, Card, Form, Icon, Input, InputNumber, Select, Radio} from 'antd';

const AddDetails = ({onAdd, grammar, form, tabName, authUser, filters, fetchRelationshipSearchData, assetData}) => {
  const [name, setName] = useState('');
  const [value, setValue] = useState('');
  const [subValue, setSubvalue] = useState('');
  const [manager, setManager] = useState('');
  const [manpowers, setManpowers] = useState([]);
  const [priority, setPriority] = useState(1);
  const [selectDatas, setSelectDatas] = useState([]);
  const [selectSubDatas, setSelectSubDatas] = useState([]);

  const handleSubmit = (event) => {
    // console.log(name, value, subValue, manager, priority);
    event.preventDefault();
    if (name && value !== '' && manager && priority) {
      // console.log(name, value, manager, priority);
      onAdd({name, value, subValue, manager, priority});
      setName('');
      setValue('');
      setSubvalue('');
      setManager('');
      setPriority(1);
    }
  };

  const fetchAssetSearch = (value, type = 'Asset') => {
    // console.log('code searching!!')
    if (value && value.length >= 3) {
      if (type === 'Asset')
        fetchRelationshipSearchData(value, 'Asset', 'assetCode');
    }
  };

  useEffect(() => {
    setManpowers(filters.manpower && filters.manpower.data && filters.manpower.data.data || []);
    const categories = filters.category && filters.category.data && filters.category.data.data || [];
    const types = filters.type && filters.type.data && filters.type.data.data || [];
    const subTypes = filters.subType && filters.subType.data && filters.subType.data.data || [];
    const makes = filters.make && filters.make.data && filters.make.data.data || [];
    const models = filters.model && filters.model.data && filters.model.data.data || [];
    const owners = filters.owner && filters.owner.data && filters.owner.data.data || [];
    switch (tabName) {
      case 'location':
        setSelectDatas(authUser && authUser.locations);
        setSelectSubDatas(authUser && authUser.clients);
        break
      case 'assetCategory':
        setSelectDatas(categories);
        break
      case 'assetType':
        setSelectDatas(types);
        break
      case 'assetSubType':
        setSelectDatas(subTypes);
        break
      case 'assetMake':
        setSelectDatas(makes);
        break
      case 'assetModel':
        setSelectDatas(models);
        break
      case 'owner':
        setSelectDatas(owners);
        break
      case 'assetCode':
        setSelectDatas(assetData);
        break
    }
    // console.log('first')
  }, [filters]);

  useEffect(() => {
    // console.log('code')
    // setManpowers(filters.manpower && filters.manpower.data && filters.manpower.data.data || []);
    setManpowers(filters.manpower && filters.manpower.data && filters.manpower.data.data || []);
    const categories = filters.category && filters.category.data && filters.category.data.data || [];
    const types = filters.type && filters.type.data && filters.type.data.data || [];
    const subTypes = filters.subType && filters.subType.data && filters.subType.data.data || [];
    const makes = filters.make && filters.make.data && filters.make.data.data || [];
    const models = filters.model && filters.model.data && filters.model.data.data || [];
    const owners = filters.owner && filters.owner.data && filters.owner.data.data || [];
    switch (tabName) {
      case 'location':
        setSelectDatas(authUser && authUser.locations);
        setSelectSubDatas(authUser && authUser.clients);
        break
      // case 'subLocation':
      //     setSelectDatas(authUser && authUser.clients);
      //     break
      case 'assetCategory':
        setSelectDatas(categories);
        break
      case 'assetType':
        setSelectDatas(types);
        break
      case 'assetSubType':
        setSelectDatas(subTypes);
        break
      case 'assetMake':
        setSelectDatas(makes);
        break
      case 'assetModel':
        setSelectDatas(models);
        break
      case 'owner':
        setSelectDatas(owners);
        break
      case 'assetCode':
        setSelectDatas(assetData);
        break
      default  :
        setSelectDatas(authUser && authUser.locations);
        break
    }
  }, [assetData, fetchRelationshipSearchData, filters]);
  // console.log(manpowers)
  return (
    <div style={{width: '100%'}}>

      <Form layout={'inline'} style={{width: '100%'}}>
        <Form.Item label={`All Assets ${grammar} ${tabName}`}>

          <Select
            // size={'small'}
            value={value}
            style={{width: '100%'}}
            showSearch
            filterOption={(input, option) =>
              (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
            }
            onSelect={(e) => {
              // console.log(tabName, e);
              setName(tabName);
              setValue(e);
            }}
            onSearch={(val) => tabName === 'assetCode' ? fetchAssetSearch(val, 'Asset') : null}
            // onChange={value => this.handleSelect('asset', value)}
            placeholder="Please select">

            <Select.Option key={0}
                           title={'All'}
                           value={0}>{'All'}</Select.Option>
            {(selectDatas || []).map(item =>
              <Select.Option key={item._id}
                             title={tabName === 'assetCode' ? item.assetCode : item.name}
                             value={item._id}>{tabName === 'assetCode' ? item.assetCode : item.name}</Select.Option>)}
          </Select>
        </Form.Item>
        {tabName === 'location' ?
          <Form.Item label={'and Sub Location'}>

            <Select
              // size={'small'}
              value={subValue}
              style={{width: '100%'}}
              showSearch
              filterOption={(input, option) =>
                (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
              }
              onSelect={(e) => {
                // console.log(tabName, e);
                // setName(tabName);
                setSubvalue(e);
              }}
              defaultValue={0}
              // onSearch={(val) => tabName === 'assetCode' ? fetchAssetSearch(val, 'Asset') : null}
              // onChange={value => this.handleSelect('asset', value)}
              placeholder="Please select">
              <Select.Option key={0}
                             title={'All'}
                             value={0}>{'All'}</Select.Option>
              {(selectSubDatas || []).map(item =>
                <Select.Option key={item._id}
                               title={item.name}
                               value={item._id}>{item.name}</Select.Option>)}
            </Select>
          </Form.Item> : <Form.Item/>
        }

        <Form.Item label={`${tabName === 'assetCode' ? 'is' : 'are'} managed by `}>
          <Select
            // size={'small'}
            required={true}
            value={manager}
            style={{width: '100%'}}
            showSearch
            filterOption={(input, option) =>
              (option.props.children + "").toLowerCase().indexOf((input + "").toLowerCase()) >= 0
            }
            onSelect={(id) => {
              setName(tabName);
              setManager(id);
            }}
            placeholder="Please select">
            {(manpowers || []).map(item =>
              <Select.Option key={item._id} title={item.name}
                             value={item._id}>{item.name}</Select.Option>)}
          </Select>
        </Form.Item>

        <Form.Item>
          <Button style={{border: '1px #038fde solid', marginTop: '25px'}} htmlType={'submit'} type="default"
                  onClick={handleSubmit} icon="plus">Add new
            Rule</Button>
        </Form.Item>
      </Form>
    </div>
  );
};

export default AddDetails;
